import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/fv_top_pc.png'
import _imports_1 from '@/assets/img/fv_top_sp.png'
import _imports_2 from '@/assets/img/fv_logo.svg'
import _imports_3 from '@/assets/img/fv_title.svg'
import _imports_4 from '@/assets/img/fv_title_sp.svg'


const _withScopeId = n => (_pushScopeId("data-v-2b6cc8cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fv" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sp-none",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pc-none",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "fv-content_logo",
    src: _imports_2,
    alt: "HIROSHIMA SANDBOX × NTT docomo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "fv-content_title sp-none",
    src: _imports_3,
    alt: "LOVE&PEACE ONLINE SESSION"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "fv-content_title pc-none",
    src: _imports_4,
    alt: "LOVE&PEACE ONLINE SESSION"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "date" }, [
    /*#__PURE__*/_createTextVNode("2021."),
    /*#__PURE__*/_createElementVNode("span", null, "12.18"),
    /*#__PURE__*/_createTextVNode(" Sat.")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "time" }, "10:00-18:00")
], -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_5))
}